import React, { useEffect, useState } from "react";
import ItemIcon1 from "../images/icons/icon-1.svg";
import ItemIcon2 from "../images/icons/icon-2.svg";
import ItemIcon3 from "../images/icons/icon-3.svg";
import ItemIcon4 from "../images/icons/s-1.svg";
import ItemIcon5 from "../images/icons/s-2.svg";
import ItemIcon6 from "../images/icons/s-3.svg";
import ItemIcon7 from "../images/icons/s-4.svg";
import ItemIcon8 from "../images/icons/d-1.svg";
import ItemIcon9 from "../images/icons/d-2.svg";
import ItemIcon10 from "../images/icons/d-3.svg";
import ItemIcon11 from "../images/icons/d-4.svg";
import ItemIcon12 from "../images/icons/c-1.svg";
import ItemIcon13 from "../images/icons/c-2.svg";
import ItemIcon14 from "../images/icons/c-3.svg";
import ItemIcon15 from "../images/icons/c-4.svg";
import ItemIcon16 from "../images/icons/r-1.svg";
import ItemIcon17 from "../images/icons/r-2.svg";
import ItemIcon18 from "../images/icons/r-3.svg";
import ItemIcon19 from "../images/icons/h-1.svg";
import ItemIcon20 from "../images/icons/h-2.svg";
import ItemIcon21 from "../images/icons/h-3.svg";
import ItemIcon22 from "../images/icons/h-4.svg";
import ItemIcon23 from "../images/icons/h-5.svg";
import AboutImage from "../images/about-1.svg";
import App1 from "../images/phone-1.svg";
import App2 from "../images/phone-2.svg";
import App3 from "../images/phone-3.svg";
import App4 from "../images/phone-4.svg";
import App5 from "../images/phone-5.svg";

const Home = ({ sectionRef }) => {
  const [opacities, setOpacities] = useState({
    bg1: 1,
    bg2: 1,
    bg3: 1,
    bg4: 1,
    bg5: 1,
  });

  useEffect(() => {
    const handleScroll = () => {
      const fadeSpeed = 2000; // Adjust fade speed here
      const newOpacities = {};

      // Select each section by ID or class name
      ["bg1", "bg2", "bg3", "bg4", "bg5"].forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          // Calculate opacity based on the element's position
          const opacity =
            1 -
            Math.min(
              Math.max((rect.top - window.innerHeight) / fadeSpeed, 0),
              1
            );
          newOpacities[id] = opacity;
        }
      });

      setOpacities(newOpacities);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="home-page">
      <section className="about-1">
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12 d-flex justify-content-center">
            <img
              src={AboutImage}
              alt="about"
              className="img-fluid animated-img"
              height={270}
              width={270}
            />
          </div>
          <div className="col-md-5 col-lg-5 col-sm-12">
            <h2>What is DTAK?</h2>
            <p className="mb-4">
              The Decentralized Team Awareness Kit (DTAK) is an innovative
              mobile application designed for secure, Decentralized
              communication and collaboration. By leveraging cutting-edge
              technology, it empowers individuals and organizations to connect
              and collaborate safely and privately, free from the limitations of
              traditional centralized systems.
            </p>
            <div className="mt-5">
              <div className="item d-flex gap-4  align-items-start">
                <img
                  src={ItemIcon1}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h3 className="grediant">Our Mission</h3>
                  <p>
                    At DTAK, our mission is to deliver secure, Decentralized
                    communication and collaboration solutions that empower users
                    by prioritizing privacy and trust. We are dedicated to
                    continuous innovation, enhancing how people connect and
                    collaborate effectively.
                  </p>
                </div>
              </div>
              <div className="item d-flex gap-4 align-items-start">
                <img
                  src={ItemIcon2}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h3 className="grediant">Core Values</h3>
                  <p className="mb-0">
                    <b>Privacy</b>: Control over personal data.
                  </p>
                  <p className="mb-0">
                    <b>Security</b>: Robust protection for communications.
                  </p>
                  <p className="mb-0">
                    <b>Innovation</b>: Continuous advancement in technology.
                  </p>
                  <p>
                    <b>User Empowerment</b>: Tools for confident collaboration.
                  </p>
                </div>
              </div>
              <div className="item d-flex gap-4 align-items-start">
                <img
                  src={ItemIcon3}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h3 className="grediant">History</h3>
                  <p>
                    <b>DTAK</b> originated from <b>CivTAK,</b> a platform
                    initially designed for secure communication in civic
                    contexts. Recognizing the growing demand for Decentralized
                    solutions, CivTAK evolved into DTAK, broadening its focus to
                    deliver secure, private communication and collaboration
                    tools for both individuals and organizations. This
                    transition reflects our commitment to continuous innovation
                    and user empowerment in an increasingly digital world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-1 mb-2" ref={sectionRef}>
        <div className="d-flex justify-content-center">
          <h2>Key Features</h2>
        </div>
      </section>
      <section className="about-2">
        <div id="bg1" className="bg-1" style={{ opacity: opacities.bg1 }}>
          <div className="row padding-64">
            <div class="col-md-6 col-lg-6 col-sm-12 offset-md-6 offset-lg-6">
              <h3>Secure Communication</h3>
            </div>
            <div class="col-md-4 col-lg-4 offset-md-2 offset-lg-2 col-sm-12 mb-3 center-image">
              <img
                src={App1}
                alt="item-icon"
                className="img-fluid"
                height={400}
                width={230}
              />
            </div>
            <div class="col-md-5 col-lg-5 col-sm-12">
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon4}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">End-to-End Encryption (E2EE)</h4>
                  <p>
                    E2EE ensures that only the sender and recipient can access
                    data, significantly enhancing privacy and security. This
                    encryption protects transactions and personal information,
                    preventing unauthorized access even if data is intercepted,
                    thus maintaining the integrity of sensitive communications.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon5}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Real-Time Messaging</h4>
                  <p>
                    Real-time messaging enables instant communication between
                    users within a blockchain network, providing immediate
                    updates on transactions. This feature enhances collaboration
                    by ensuring that shared information remains secure and
                    maintains data integrity.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon6}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Voice and Video Calls</h4>
                  <p>
                    Voice and video calls on the blockchain enable secure,
                    peer-to-peer communication with enhanced privacy. By
                    utilizing encryption, these calls ensure that conversations
                    are protected from unauthorized access while leveraging
                    Decentralized infrastructure for increased reliability.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon7}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Group Chat</h4>
                  <p>
                    Group chat features in blockchain enable multiple users to
                    communicate simultaneously in a secure environment. These
                    chats benefit from encryption and Decentralized storage,
                    ensuring both privacy and data integrity while fostering
                    collaboration among participants.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="bg2" className="bg-2" style={{ opacity: opacities.bg2 }}>
          <div className="row  padding-64">
            <div className="col-md-11 col-lg-11 offset-md-1 offset-lg-1 col-sm-12">
              <h3 className="grediant">Decentralized Network</h3>
            </div>
            <div className="col-md-5 col-lg-5 offset-md-1 offset-lg-1 col-sm-12">
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon8}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">Decentralized Network</h4>
                  <p>
                    A Decentralized network distributes control across multiple
                    nodes, enhancing security and resilience. It facilitates
                    peer-to-peer interactions without a central authority,
                    fostering transparency and trust among users.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon9}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">
                    Self-Sovereign Identity Management
                  </h4>
                  <p>
                    Self-sovereign identity (SSI) empowers users to take control
                    of their own digital identities without relying on a central
                    authority. In Decentralized networks, SSI enables
                    individuals to securely manage and share their personal
                    data, enhancing privacy and reducing the risk of identity
                    theft.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon10}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">
                    Biometric Authentication
                  </h4>
                  <p>
                    Biometric authentication uses unique physical traits, such
                    as fingerprints or facial recognition, to verify identity in
                    Decentralized networks. This method enhances security by
                    ensuring that only authorized users can access sensitive
                    data while minimizing reliance on passwords or central
                    identity providers.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon11}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">Hardware Root of Trust</h4>
                  <p>
                    A hardware root of trust establishes a secure foundation for
                    identity and data integrity within Decentralized networks.
                    It utilizes dedicated hardware to store cryptographic keys
                    and verify device identities, enhancing security by ensuring
                    that only trusted devices can participate in the network.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 offset-md-2 offset-lg-2 col-sm-12 center-image">
              <img
                src={App2}
                alt="item-icon"
                className="img-fluid"
                height={400}
                width={230}
              />
            </div>
          </div>
        </div>
        <div id="bg3" className="bg-3" style={{ opacity: opacities.bg3 }}>
          <div className="row padding-64">
            <div className="col-md-6 col-lg-6 col-sm-12 offset-md-6 offset-lg-6">
              <h3>Collaborative Mapping</h3>
            </div>
            <div className="col-md-4 col-lg-4 offset-md-2 offset-lg-2 col-sm-12 mb-3 center-image">
              <img
                src={App3}
                alt="item-icon"
                className="img-fluid"
                height={400}
                width={230}
              />
            </div>
            <div className="col-md-5 col-lg-5 col-sm-12">
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon12}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Magnetic GPS</h4>
                  <p>
                    Magnetic GPS enhances location accuracy by integrating
                    magnetic field data, allowing for precise positioning in
                    environments where traditional GPS may falter. This
                    technology improves navigation and collaboration in shared
                    mapping applications.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon13}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Real-Time Map Sharing</h4>
                  <p>
                    Real-time map sharing enables users to instantly update and
                    view map changes, facilitating seamless collaboration. This
                    feature allows teams to coordinate their efforts
                    effectively, ensuring everyone has access to the most
                    current information.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon14}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Annotations and Markers</h4>
                  <p>
                    Annotations and markers enable users to add notes,
                    highlights, or symbols on shared maps. This functionality
                    enhances communication by providing context and insights,
                    making it easier for collaborators to understand specific
                    locations or features.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon15}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Geolocation Tracking</h4>
                  <p>
                    Geolocation tracking allows users to view their real-time
                    positions on a collaborative map. This feature enhances
                    coordination and situational awareness, making it easier for
                    teams to navigate and manage shared projects.
                  </p>
                </div>
              </div>{" "}
            </div>
          </div>
        </div>
        <div id="bg4" className="bg-4" style={{ opacity: opacities.bg4 }}>
          <div className="row padding-64">
            <div className="col-md-11 col-lg-11 offset-md-1 offset-lg-1 col-sm-12">
              <h3 className="grediant">Real-Time Data Sharing</h3>
            </div>
            <div className="col-md-5 col-lg-5 offset-md-1 offset-lg-1 col-sm-12">
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon16}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">
                    Integration with Decentralized Storage (IPFS)
                  </h4>
                  <p>
                    Integrating IPFS allows for efficient, secure storage of
                    data in real time, ensuring that shared information remains
                    Decentralized and tamper-proof. This enhances data
                    availability and reduces reliance on central servers.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon17}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">
                    Integration with Sensors and Devices
                  </h4>
                  <p>
                    Integrating sensors and devices enables the collection and
                    sharing of real-time data directly from its source. This
                    integration provides immediate insights, improving
                    decision-making and operational efficiency.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon18}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1 grediant">
                    Data Visualization and Analytics
                  </h4>
                  <p>
                    Data visualization and analytics transform raw data into
                    actionable insights using dynamic charts and dashboards.
                    These tools help users quickly identify trends and patterns,
                    enabling informed decisions based on real-time information.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 offset-md-2 offset-lg-2 col-sm-12 center-image">
              <img
                src={App4}
                alt="item-icon"
                className="img-fluid"
                height={400}
                width={230}
              />
            </div>
          </div>
        </div>
        <div id="bg5" className="bg-5" style={{ opacity: opacities.bg5 }}>
          <div className="row padding-64">
            <div className="col-md-8 col-lg-8 col-sm-12 offset-md-4 offset-lg-4">
              <h3>Hardware Edge Nodes</h3>
            </div>
            <div className="col-md-3 col-lg-3 offset-md-1 offset-lg-1 col-sm-12 mb-3 center-image">
              <img
                src={App5}
                alt="item-icon"
                className="img-fluid"
                height={400}
                width={230}
              />
            </div>
            <div className="col-md-7 col-lg-7 col-sm-12">
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon19}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">
                    Authentication Through Edge Nodes
                  </h4>
                  <p>
                    In blockchain networks, authentication through edge nodes
                    enables Decentralized identity verification closer to the
                    user, improving speed and reducing latency. This approach
                    enhances security by ensuring that only trusted devices
                    access the blockchain, while distributing the authentication
                    load across the network to increase resilience and
                    efficiency.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon20}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">
                    Decentralized Routing for Communication
                  </h4>
                  <p>
                    Decentralized routing allows data to be transmitted across a
                    network without relying on a central authority. This method
                    improves resilience and security by enabling multiple data
                    paths, reducing bottlenecks and points of failure, while
                    promoting greater privacy and control for users during
                    communication.
                  </p>
                </div>
              </div>
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon21}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">
                    Enhanced Performance and Security
                  </h4>
                  <p>
                    Decentralized systems improve performance and security by
                    distributing workloads and data across multiple nodes,
                    reducing latency and increasing throughput. Robust
                    encryption and authentication measures safeguard sensitive
                    information, fostering user trust and ensuring system
                    reliability.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon22}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">Offload Processing Tasks</h4>
                  <p>
                    Offloading processing tasks distributes workloads from a
                    central server to multiple edge devices or nodes. This
                    strategy enhances system performance by reducing latency and
                    bandwidth usage, enabling real-time data processing and
                    improving efficiency within Decentralized networks.
                  </p>
                </div>
              </div>{" "}
              <div className="d-flex gap-4 mb-1 align-items-start">
                <img
                  src={ItemIcon23}
                  alt="item-icon"
                  className="img-fluid"
                  height={48}
                  width={48}
                />
                <div>
                  <h4 className="mt-3 mb-1">
                    Edge Processing with AI and ML Models
                  </h4>
                  <p>
                    Edge processing with AI and machine learning models allows
                    data analysis and decision-making directly on edge devices,
                    minimizing the need to send data to centralized servers.
                    This approach enhances response times, reduces bandwidth
                    usage, and improves privacy by keeping sensitive data local,
                    providing real-time insights and actions for Decentralized
                    applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
